import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingPullToRefresh = _resolveComponent("LoadingPullToRefresh")

  return (_openBlock(), _createBlock("div", {
    class: "pulltorefresh",
    style: _ctx.styleTop,
    onTouchstart: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.touchStart(...args))),
    onTouchmove: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.touchMove(...args))),
    onTouchEnd: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.touchEnd(...args)))
  }, [
    _createVNode(_component_LoadingPullToRefresh, {
      show: _ctx.showPullToRefresh,
      "topPosition:": _ctx.topLoadingPosition
    }, null, 8, ["show", "topPosition:"]),
    _renderSlot(_ctx.$slots, "default")
  ], 36))
}